export type Grouping =
  | "series"
  | "by_vintage"
  | "by_asset_class"
  | "by_stage"
  | "by_sector"
  | "by_portfolio_company"

export type View = "performance" | "quarter_activity" | "ytd"

export const formatCurrency = (value: number | null | undefined): string => {
  if (value == null) return "—"
  const abs = Math.abs(value)
  const sign = value < 0 ? "-" : ""
  if (abs >= 1000000) {
    return `${sign}$${(abs / 1000000).toFixed(1)}M`
  }
  if (abs >= 1000) {
    return `${sign}$${(abs / 1000).toFixed(0)}K`
  }
  return `${sign}$${abs.toFixed(0)}`
}

export const formatCurrencyFull = (
  value: number | null | undefined,
): string => {
  if (value == null) return "—"
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const formatPercent = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return "—"
  return `${Math.round(value * 100)}%`
}

export const formatTvpi = (
  value: number | string | null | undefined,
): string => {
  if (value == null) return "—"
  const n = Number(value)
  if (isNaN(n)) return "—"
  return `${n.toFixed(2)}x`
}

export const formatIrr = (
  value: number | string | null | undefined,
): string => {
  if (value == null) return "—"
  const n = Number(value)
  if (isNaN(n)) return "—"
  return `${n.toFixed(1)}%`
}

export const formatAge = (value: number | null | undefined): string => {
  if (value == null) return "—"
  return String(value)
}
